<template>
    <v-app>
        <v-main class="bg-image-login">
            <v-container
                class="fill-height"
                fluid>
                <router-view></router-view>
            </v-container>
        </v-main>
        <snackbar-alert></snackbar-alert>
    </v-app>
</template>

<script>
import SnackbarAlert from '../components/common/SnackbarAlert.vue'
  export default {
  components: { SnackbarAlert },
    props: {
      source: String,
    },
  }
</script>

<style scoped>

.bg-image-login {
  background-image: url('~@/assets/petra1.jpg');
  background-position: center;
  background-size: cover;
}

</style>